var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CardWrapper",
    {
      staticClass: "last-transactions-widget",
      attrs: {
        "data-test-id": "last-transactions-widget",
        title: _vm.i18n.dash_activity()
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "title-btns" },
                [
                  _c("RoundButton", {
                    attrs: {
                      size: "sm",
                      testId: "last-transactions-widget-refresh-btn",
                      icon: "autorenew"
                    },
                    on: { click: _vm.refresh }
                  }),
                  _vm._v(" "),
                  _vm.resultList.length
                    ? _c(
                        "md-button",
                        {
                          staticClass: "simple-link arrow",
                          attrs: {
                            to: "/history/index",
                            disabled: _vm.accountState !== "approved",
                            "data-test-id":
                              "last-transactions-widget-history-link"
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.i18n.lbl_all_history()) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "last-transactions-widget__table-wrapper",
          attrs: { "data-test-id": "last-transactions-widget-table-wrapper" }
        },
        [
          _vm.resultList.length
            ? _c(
                "table",
                {
                  staticClass: "last-transactions-widget__table",
                  attrs: { "data-test-id": "last-transactions-widget-table" }
                },
                [
                  _c(
                    "thead",
                    {
                      attrs: {
                        "data-test-id": "last-transactions-widget-table-header"
                      }
                    },
                    [
                      _c("tr", [
                        _c("th", [_vm._v(_vm._s(_vm.i18n.operation_type()))]),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.i18n.lbl_counterparty()))]),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.i18n.lbl_date()))]),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.i18n.lbl_amount()))]),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.i18n.lbl_status()))])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    {
                      attrs: {
                        "data-test-id": "last-transactions-widget-table-body"
                      }
                    },
                    _vm._l(_vm.resultList, function(tx, i) {
                      return _c(
                        "tr",
                        {
                          key: i,
                          class: [
                            { row_opacity: _vm.checkRowForFailed(tx) },
                            { row_gray: _vm.checkGrayRow(tx) }
                          ],
                          attrs: {
                            "data-test-id":
                              "last-transactions-widget-table-row-" + i
                          },
                          on: {
                            click: function($event) {
                              return _vm.makeDialogIsShow(tx)
                            }
                          }
                        },
                        [
                          _c(
                            "td",
                            {
                              staticClass: "text_bold operation-type",
                              attrs: {
                                "data-test-id":
                                  "last-transactions-widget-table-type-cell"
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(tx.name) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "counterparty text-ellipsis",
                              attrs: {
                                "data-test-id":
                                  "last-transactions-widget-table-counterparty-cell"
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    tx.counterparty ? tx.counterparty : "-"
                                  ) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              attrs: {
                                "data-test-id":
                                  "last-transactions-widget-table-date-cell"
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(tx.date) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              class: [
                                "amount",
                                "amount_" + tx.direction,
                                tx.state === "pending" ? "amount_pending" : "",
                                _vm.checkRowForFailed(tx) ? "amount_failed" : ""
                              ],
                              attrs: {
                                "data-test-id":
                                  "last-transactions-widget-table-amount-cell"
                              }
                            },
                            [
                              _c(
                                "md-tooltip",
                                {
                                  staticClass: "custom-menu-tooltip",
                                  attrs: {
                                    "md-direction": "top",
                                    "data-test-id":
                                      "last-transactions-widget-table-fees-tooltip"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.i18n.lbl_fees_label()))
                                  ]),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.i18n.c(
                                          _vm.swimAmount(
                                            tx.asset,
                                            _vm.getTotalFees(tx)
                                          )
                                        )
                                      ) +
                                      " " +
                                      _vm._s(_vm.formatAsset(tx.asset)) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(
                                "\n            " +
                                  _vm._s(tx.direction === "in" ? "+" : "-") +
                                  "\n            " +
                                  _vm._s(_vm.swimAmount(tx.asset, tx.amount)) +
                                  "\n            " +
                                  _vm._s(_vm.formatAsset(tx.asset)) +
                                  "\n          "
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              class: ["status", tx.state],
                              attrs: {
                                "data-test-id":
                                  "last-transactions-widget-table-status-cell"
                              }
                            },
                            [
                              _c("span", { staticClass: "status__indicator" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "status__text" }, [
                                _vm._v(_vm._s(_vm.i18n.tx_state(tx.state)))
                              ])
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "last-transactions-widget__empty text-center",
                  attrs: {
                    "data-test-id": "last-transactions-widget-empty-table"
                  }
                },
                [
                  _c(
                    "md-icon",
                    {
                      staticClass: "md-size-4x",
                      attrs: {
                        "data-test-id":
                          "last-transactions-widget-empty-table-icon"
                      }
                    },
                    [_vm._v("\n        trending_up\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text_xl_large",
                      attrs: {
                        "data-test-id":
                          "last-transactions-widget-empty-table-title"
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.i18n.th_no_transaction_history()) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text_margin text_medium",
                      attrs: {
                        "data-test-id":
                          "last-transactions-widget-empty-table-msg"
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.i18n.th_no_transaction_history_search())
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "contact-us__link",
                          attrs: {
                            "data-test-id":
                              "last-transactions-widget-empty-table-dialog-link"
                          },
                          on: {
                            click: function($event) {
                              _vm.showContactDialog = true
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.i18n.lbl_contact_us()) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.i18n.th_no_transaction_history_search_end()
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              )
        ]
      ),
      _vm._v(" "),
      _vm.showInfoDialog
        ? _c("info-dialog", {
            attrs: {
              dialogValues: _vm.dialogValues,
              showDialog: _vm.showInfoDialog,
              "data-test-id": "last-transactions-widget-info-dialog"
            },
            on: { "close-dialog": _vm.closeDialog }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showContactDialog
        ? _c("contact-us", {
            staticClass: "contact-us__popup",
            attrs: {
              "data-test-id": "last-transactions-widget-contact-dialog",
              showDialog: _vm.showContactDialog
            },
            on: {
              "close-dialog": function($event) {
                _vm.showContactDialog = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-224b40fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-224b40fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/widgets/LastTransactionsWidget.vue
// module id = Txej
// module chunks = 1